<template>
  <div>
    <h3>{{survey.name}}</h3>
    <h4>{{question.name}}</h4>
    <b-form v-on:submit.prevent="submit()" validated novalidateenc type="multipart/form-data">
      <b-form-group label-for="Name" label="Option">
        <b-form-input type="text" class="form-control-warning" id="Option" v-model="option.name" required></b-form-input>
        <b-form-valid-feedback>
        Valid option provided.
        </b-form-valid-feedback>
        <b-form-invalid-feedback>
        Enter option.
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="mt-4 text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/surveys/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-form>
  </div>
</template>
<script>
export default {
  name: 'optionitem',
  props: ['survey','question','option'],
  computed: {
    typeList: function () {
      let types = [];
      types.push({text: 'Multiple Choice', value: 'multiple-choice'});
      types.push({text: 'Single Choice', value: 'single-choice'});
      types.push({text: 'Text', value: 'text'});
      return types;
    },
    optionIsEdit () {
      return this.$store.getters.optionIsEdit;
    }
  },
  methods: {
    submit () {
      
      let scope = this;
      
      if(!scope.option.name) {
            console.log('invalid')
        return
      }
      
      if(this.optionIsEdit) {
        scope.$store.dispatch('updateOption', scope.option).then(result => {
          this.$store.commit('updateSurveyMode', 'step-survey');
          this.$store.dispatch('getSurvey', scope.survey._id);
        }, error => {
          console.log(error);
        });
      } else {
        scope.option.question = scope.question._id;
        scope.option.user = scope.$store.getters.currentUser.id;
        scope.$store.dispatch('addOption', scope.option).then(result => {
          this.$store.commit('updateSurveyMode', 'step-survey');
          this.$store.dispatch('getSurvey', scope.survey._id);
        }, error => {
          console.log(error);
        });
      }
    }
  }
}
</script>
